import { ApiType, ApiEndpoint } from "/shortcodes";
import * as React from 'react';
export default {
  ApiType,
  ApiEndpoint,
  React
};